import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import CategoryArticle from '../../CategoryArticle';

const CategoryRoute = () => [
  <Route path={ROUTES.CATEGORY.ARTICLE} key={ROUTES.CATEGORY.ARTICLE} component={CategoryArticle} />,
];

export default CategoryRoute;
